import "@/styles/globals.css";
import GridOverlay from "@/components/ui/GridOverlay";
import TransitionLayout from "@/components/Transition";
import cmsClient from "@/lib/cmsClient";



export async function getStaticProps({locale}) {
  try {
    const data = await cmsClient("general", {}, {language: locale}) 
    return {
      props: {
        data,
      },
    }
  } catch (error) {
    return {
      props: {
        posts: [],
      },
    }
  }
}

export default function App({ Component, pageProps, router, data }) {


  return (
      <>

        {/* <GridOverlay/> */}
        <TransitionLayout>
            <Component key={router.route} {...pageProps} />
        </TransitionLayout>
      </>
  );
}
